<template>
  <div class="mt-2">
    <RuleWrapper
      :class="rule.rule.type === ruleType.composite ? 'composite' : ''"
    >
      <h3 class="d-flex align-items-center py-3 mb-0 title-bar">
        <AdditionalExplanation
          class="ms-3 text-size"
          :text="trans('subscription.validation_rules.validation_rules_explanation')"
        >
          <span
            class="fa fa-info-circle"
          />
        </AdditionalExplanation>
        {{ trans('subscription.validation_rules.validation_rules') }}
      </h3>
      <template v-if="rule && rule.rule && rule.rule.rules">
        <RuleHeader
          :rule="rule.rule"
          :display-delete="false"
          :rule-reference="rule.rule.reference"
          :title="rule.rule.type"
        />
        <RuleComposite
          :key="counter"
          is-first
          :rules="rule.rule.rules"
          :rule-reference="rule.rule.reference"
        />
      </template>
    </RuleWrapper>
  </div>
</template>

<script>
import { RULE_TYPE } from '@/constants'
import { addReferences, addRuleProperty, buildBaseRule, buildCompositeRule, deleteRule, deleteRuleProperty, removeReferences, ruleOperatorChange, searchParentAddChild } from '@/employees/components/Rule/utilities/builder/ruleBuilder'
import AdditionalExplanation from '@/employees/components/AdditionalExplanation'
export default {
  name: 'RuleBuilder',
  components: { AdditionalExplanation },
  props: {
    value: {
      required: false,
      type: String,
      default: null,
    },
  },
  data () {
    return {
      rule: null,
      //* The counter value is used to force a rerender after a nested object has being changed
      counter: 0,
      ruleType: RULE_TYPE,
    }
  },
  watch: {
    rule: {
      deep: true,
      immediate: true,
      handler () {
        this.emitChangeEvent()
      },
    },
    counter: {
      deep: true,
      immediate: true,
      handler () {
        this.emitChangeEvent()
      },
    },
  },
  created () {
    if (this.value === null) {
      this.rule = buildBaseRule(buildCompositeRule())
    } else {
      this.rule = addReferences(JSON.parse(this.value))
    }
    this.$root.$on('AddRule', this.addRule)
    this.$root.$on('RemoveRule', this.removeRule)
    this.$root.$on('RuleOperatorChange', this.ruleOperatorChange)
    this.$root.$on('RulePropertyValueAdd', this.rulePropertyValueAdd)
    this.$root.$on('RulePropertyValueChange', this.rulePropertyValueAdd)
    this.$root.$on('RulePropertyValueDelete', this.rulePropertyValueDelete)
  },
  destroyed () {
    this.$root.$off('AddRule', this.addRule)
    this.$root.$off('RemoveRule', this.removeRule)
    this.$root.$off('RuleOperatorChange', this.ruleOperatorChange)
    this.$root.$off('RulePropertyValueAdd', this.rulePropertyValueAdd)
    this.$root.$off('RulePropertyValueChange', this.rulePropertyValueAdd)
    this.$root.$off('RulePropertyValueDelete', this.rulePropertyValueDelete)
    this.$store.dispatch('clear_display_rule_map')
  },
  methods: {
    addRule (value) {
      if (this.rule) {
        searchParentAddChild(this.rule.rule, value[0], value[1], value[2])
        this.counter++
      }
    },
    removeRule (value) {
      if (this.rule) {
        deleteRule(this.rule.rule, value[0])
      }
    },
    ruleOperatorChange (value) {
      if (this.rule) {
        ruleOperatorChange(this.rule.rule, value[0], value[1], value[2])
        this.counter++
      }
    },
    rulePropertyValueAdd (value) {
      if (this.rule) {
        addRuleProperty(this.rule.rule, value[0], value[1], value[2])
        this.counter++
      }
    },
    rulePropertyValueDelete (value) {
      if (this.rule) {
        deleteRuleProperty(this.rule.rule, value[0], value[1], value[2])
        this.counter++
      }
    },
    emitChangeEvent () {
      if (this.rule) {
        this.$emit('input', JSON.stringify(removeReferences(this.rule)))
      }
    },
  },
}
</script>

<style scoped>
.title-bar {
  background-color: rgba(0, 0, 0, 0.06);
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  width: 100%;
}
</style>
